import Link from "next/link";
import React from "react";
import styles from "./Card.module.css";
import { Figure, FigureProps } from "./Figure";
import { Icon } from "./Icon";
import cx from "classnames";
import { LinkWrapper } from "./linkWrapper";

export type CardProps = {
  title: string;
  subject: string;
  external: boolean;
  video: boolean;
  url: string;
  image: FigureProps["image"];
};

export const Card = ({
  title,
  subject,
  external,
  video,
  url,
  image,
}: CardProps) => {
  return (
    <LinkWrapper url={url} className={styles.card}>
      <div className={styles.imageWrapper}>
        <Figure
          image={image}
          styled={false}
          className={styles.image}
          width={360}
          height={240}
        />
        {video && <Icon icon="play" className={styles.iconPlay} />}
      </div>
      <div className={cx(styles.text, "text")}>
        <h3 className={styles.title}>{title}</h3>
        {subject && (
          <p className={styles.subject}>
            {subject}
            {external && (
              <Icon icon="external" className={styles.iconExternal} />
            )}
          </p>
        )}
      </div>
    </LinkWrapper>
  );
};
